module.exports = __webpack_public_path__ + "static/media/filter.17072106.svg";